// fleet-generated: do not edit by hand
//
// Copied verbatim  : infra/fleet/artifacts/typography/font-downloader.ts
// Parameters       : none — below this header, identical across the fleet
// Destination      : packages/fleet/typography/src/font-downloader.ts
//
// TO CHANGE THIS FILE, edit the canonical copy in infra and re-render. It
// changes for the whole fleet at once. Editing it here is reverted by the
// next render, and the guard in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo tendly-app
//     node fleet/fleet.ts check --repo tendly-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
/**
 * Font downloader — pure types, constants and platform-agnostic utilities.
 */

import type { FontCategory, FontWeight } from "./font-catalog";

export const INGESTABLE_WEIGHTS = [
  "100",
  "200",
  "300",
  "400",
  "500",
  "600",
  "700",
  "800",
  "900",
] as const;
export type IngestableWeight = (typeof INGESTABLE_WEIGHTS)[number];

export interface CatalogFont {
  id: string;
  family: string;
  name: string;
  category: FontCategory;
}

export const FONT_CATEGORIES: readonly FontCategory[] = [
  "sans-serif",
  "serif",
  "display",
  "handwriting",
  "monospace",
] as const;

const FONT_WEIGHTS: ReadonlySet<string> = new Set([
  "100",
  "200",
  "300",
  "400",
  "500",
  "600",
  "700",
  "800",
  "900",
]);

const WEIGHT_NAMES: Record<FontWeight, string> = {
  "100": "Thin",
  "200": "ExtraLight",
  "300": "Light",
  "400": "Regular",
  "500": "Medium",
  "600": "SemiBold",
  "700": "Bold",
  "800": "ExtraBold",
  "900": "Black",
};

export function isFontWeight(value: string | null | undefined): value is FontWeight {
  return typeof value === "string" && FONT_WEIGHTS.has(value);
}

export function getFontKey(family: string, weight: FontWeight): string {
  const safeFamily = family.replaceAll(/\s+/g, "");
  return `${safeFamily}-${WEIGHT_NAMES[weight]}`;
}

export function getSafeFamilyName(
  font: { family?: string | null; name?: string | null; id?: string | null } | null | undefined,
): string | null {
  if (!font) {
    return null;
  }
  return font.family ?? font.name ?? font.id ?? null;
}
